console.log("global");
// Function to handle Mobile Menu
document.addEventListener("DOMContentLoaded", function () {
    const toggleButton = document.querySelector('.humberger-menu');
    const closeButton = document.querySelector('.humberger-menu-close');
    const mobileMenu = document.querySelector('.mobileMenu');
    const html = document.documentElement; // <html>

    function toggleMobileMenu() {
        mobileMenu.classList.toggle('active');
        html.classList.toggle('menu-active');
    }

    function closeMobileMenu() {
        mobileMenu.classList.remove('active');
        html.classList.remove('menu-active');
    }

    toggleButton.addEventListener('click', function () {
        toggleMobileMenu();
    });

    closeButton.addEventListener('click', function () {
        closeMobileMenu();
    });

    const menuItems = document.querySelectorAll('.mobileMenu a');
    menuItems.forEach(function (item) {
        item.addEventListener('click', function () {
            closeMobileMenu();
        });
    });

    window.addEventListener('click', function (event) {
        if (!mobileMenu.contains(event.target) && !toggleButton.contains(event.target)) {
            closeMobileMenu();
        }
    });
});


window.addEventListener('scroll', function () {
  if (window.scrollY > 100) {
    document.body.classList.add('header-fixed');
  } else {
    document.body.classList.remove('header-fixed');
  }
});


document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('gform_5');

  if (!form) return;

  form.addEventListener('change', function (e) {
    if (e.target.matches('input[type="radio"]')) {
      // Remove 'active' from all gchoice wrappers
      const allChoices = form.querySelectorAll('.gchoice');
      allChoices.forEach(choice => choice.classList.remove('active'));

      // Add 'active' to the selected radio's gchoice wrapper
      const selectedChoice = e.target.closest('.gchoice');
      if (selectedChoice) {
        selectedChoice.classList.add('active');
      }
    }
  });
});
